<template>
    <div class="page">
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}<br />
            {{ userStore.user.address }}<br />
            {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }} <br />
            {{ userStore.user.ssn }} <br />
            <br />
            {{ dataFurnisher.address_name }} <br />
            {{ dataFurnisher.street_address }} <br />
            {{ dataFurnisher.city }}, {{ dataFurnisher.state_abbrev }} {{ dataFurnisher.zipcode }}
            <br />
            <br />
            Date: {{ date }}
            <br />
            <br />
        </p>
        <p class="letter-content">
            <strong>
                PER THE FAIR CREDIT REPORTING ACT Section 605A.[15 U.S.C. 1681c-1]:
            </strong>
            I am sending you this letter to initiate my request for
            your company to place a security freeze and surpress from sharing <strong>ANY</strong>
            information about me: <strong>{{ userStore.user.firstname }} {{ userStore.user.lastname }} </strong>.
        </p>
        <p class="letter-content">
            I do not consent nor authorize the sharing of my information to the public,
            specifically with data aggregators who are looking to collect information on
            my behalf.
        </p>
        <p class="letter-content">
            I would like to have my entire credit file <strong>REMOVED</strong> from your data institution.
            Please complete my following requests:
            <br />
        </p>
        <ol>
            <li class="letter-content">
                Provide my <strong>Full Consumer File Disclosure</strong> of my credit profile: A
                complete overview, the set of documents & procedures and snapshot of my
                character including any credit information in association to my name and/or address
                listed in this document.
            </li>
            <li class="letter-content">
                Place a <strong>Security Freeze</strong> and suppress from sharing of
                any information about me to any other parties, unless otherwise
                expressly permitted by me in writing.
            </li>
            <li class="letter-content">
                Once completed, kindly write back no later than <strong>(5) days</strong> to confirm that you have in fact, placed a security
                freeze on my information as well as provide me with the information
                needed to verify the details of my information suppression.
            </li>
        </ol>
        <p>
                My <strong>Personal Information</strong> is clearly shown below: <br />
            <strong>FULL NAME:</strong> {{ userStore.user.firstname }} {{ userStore.user.lastname }} <br />
            <strong>PHONE:</strong> {{ userStore.user.phone }}<br />
            <strong>SOCIAL SECURITY NUMBER: </strong> {{ userStore.user.ssn }} <br />
            <strong>FULL CURRENT ADDRESS: </strong> {{ userStore.user.address }} {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
        </p>
        <p class="letter-content">
            After this credit freeze has been filed, please send me written confirmation to the address listed above.
            <br />
            <br />
            Sincerely, <br />
        </p>

        <p style="page-break-before: always; padding-top: 1rem; text-align: center;">
            <strong class="letter-content">
                Note: Attached you will find my drivers license. Please do not retain on record.
                Upon confirmation of my
                identity, you will need to purge the copy of the Drivers License attached. I
                do not authorize your company
                to store or share <strong>any</strong> of my Personal Identification.
            </strong>
        </p>
        <h1 style="text-align: center;">Personal Information</h1>
        <p style="padding-top: 1rem; text-align: center;">
            <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
            <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    export default {
        props: {
            dataFurnisher: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore()
            };
        }
    };
</script>